import { Row } from "react-bootstrap";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import RoundedImageWithFallback from "components/rounded-image-with-fallback";
import { getOrchidProProfileImageUrl } from "utils/formatter/orchidPro";

const SPEAKER_PLACEHOLDER = "/img/group-session/speaker-placeholder.png";

const SpeakerIcons = (props) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  const { groupSeries } = props;
  const organizer =
    groupSeries.organizer_cognito_sub || groupSeries.orchid_pro_sub;
  return (
    groupSeries.speakers && (
      <Row className="align-items-center">
        <RoundedImageWithFallback
          src={getOrchidProProfileImageUrl(organizer)}
          width={!isPhonePortrait ? 60 : 36}
          height={!isPhonePortrait ? 60 : 36}
        />
        {groupSeries.speakers.filter((speaker) => speaker !== organizer)
          .length >= 1 && (
          <>
            {groupSeries.speakers
              .filter((speaker) => speaker !== organizer)
              .slice(0, 1)
              .map((speaker, index) => {
                return (
                  <RoundedImageWithFallback
                    key={index}
                    src={getOrchidProProfileImageUrl(speaker)}
                    width={!isPhonePortrait ? 40 : 28}
                    height={!isPhonePortrait ? 40 : 28}
                    style={{
                      border: "1px solid white",
                      marginLeft: !isPhonePortrait ? "-1rem" : "-0.875rem",
                      zIndex: index + 1,
                    }}
                  />
                );
              })}
            {groupSeries.speakers.filter((speaker) => speaker !== organizer)
              .length >= 2 && (
              <RoundedImageWithFallback
                src={SPEAKER_PLACEHOLDER}
                width={!isPhonePortrait ? 40 : 28}
                height={!isPhonePortrait ? 40 : 28}
                style={{
                  // border: "1px solid white",
                  marginLeft: !isPhonePortrait ? "-1rem" : "-0.875rem",
                  zIndex: 10,
                }}
              />
            )}
          </>
        )}
      </Row>
    )
  );
};

export default SpeakerIcons;
